import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AppService } from '@app/app.service';
import { TestRoutePageModel } from '@pages/test-route-page/models/test-route-page.model';
import { TestRoutePageService } from '@pages/test-route-page/test-route-page.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TestRouteResolver implements Resolve<Observable<TestRoutePageModel | null>> {
  constructor(
    private appService: AppService,
    private testRoutePageService: TestRoutePageService,
    private router: Router
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<TestRoutePageModel | null> {
    this.appService.darkBackgroundPage();

    const sectionId = route.paramMap.get('id') as string;
    return this.testRoutePageService.getTestRoute(sectionId).pipe(
      map((data) => {
        if (!data) {
          this.router.navigate(['404'], { skipLocationChange: true });
          return null;
        } else {
          // this.appService.updateMetaData(this.magazineService.getPageMetaData)
          return data;
        }
      })
    );
  }
}
